import { trackingPageFlowStepArraySchema } from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import * as z from "zod/v4";

export const getTrackingPageFlowSteps = {
  name: "getTrackingPageFlowSteps" as const,
  input: z.object({}),
  output: z.object({ steps: trackingPageFlowStepArraySchema }),
};
